module.exports = __webpack_public_path__ + "static/media/TWL-LandingPage-Social-Image.cd1bb55d.jpg";